import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from 'api/userService';
import { notifyApiError } from 'api/apiUtils';

export const getUserInstitutions = createAsyncThunk(
  'user/institutions',
  async (_, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await userService.getUserInstitutions();
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);
